import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { PHONE, PHONE_LINK, Reveal } from "../lib/data";

const CtaBanner = () => (
  <section className="bg-[#2A2521] py-20 lg:py-24 relative overflow-hidden" data-testid="cta-banner">
    <div className="absolute inset-0 medical-grid opacity-40" />
    <div className="max-w-3xl mx-auto px-6 text-center relative">
      <Reveal>
        <h2 className="font-display text-3xl lg:text-4xl font-bold text-white">
          Zâmbetul tău te așteaptă. <span className="text-[#DCC79A]">Programează-te azi.</span>
        </h2>
        <p className="text-white/70 mt-4 text-base md:text-lg">
          Un singur telefon ne desparte. Sau lasă-ne datele și te sunăm noi.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={PHONE_LINK}
            data-testid="cta-banner-phone-button"
            className="inline-flex items-center justify-center gap-3 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold text-lg px-7 py-4 rounded-full shadow-xl shadow-[#A6823B]/25 transition-all hover:-translate-y-0.5"
          >
            <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center pulse-ring">
              <Phone className="w-4 h-4" />
            </span>
            {PHONE}
          </a>
          <Link
            to="/contact"
            data-testid="cta-banner-contact-button"
            className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-lg px-7 py-4 rounded-full transition-colors"
          >
            Trimite cerere online <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBanner;
